import React from 'react';
import PropTypes from 'prop-types';
import useFeatureFlags from 'yola-editor/src/js/modules/feature-flags/hooks/use-feature-flags';
import BlockGenerationTriggerContainer from './block-generation-trigger-container';

function BlockGenerationTriggerWrapper({
  element,
  offsetX,
  offsetY,
  viewportHeight,
  isVertical = false,
}) {
  const [
    {
      ai_block_generator: isAIBlockGeneratorEnabled,
      business_info_in_website_settings: hasBusinessInfoInWebsiteSettings,
    },
  ] = useFeatureFlags(['ai_block_generator', 'business_info_in_website_settings']);

  if (!element || !isAIBlockGeneratorEnabled) return null;

  return (
    <BlockGenerationTriggerContainer
      element={element}
      offsetX={offsetX}
      offsetY={offsetY}
      viewportHeight={viewportHeight}
      hasBusinessInfoInWebsiteSettings={hasBusinessInfoInWebsiteSettings}
      isVertical={isVertical}
    />
  );
}

BlockGenerationTriggerWrapper.propTypes = {
  element: PropTypes.object.isRequired,
  offsetX: PropTypes.number.isRequired,
  offsetY: PropTypes.number.isRequired,
  viewportHeight: PropTypes.number.isRequired,
  isVertical: PropTypes.bool,
};

export default BlockGenerationTriggerWrapper;
